import {inject, injectable} from 'inversify';

import type {DateTimeModel} from '../../../../core/domain/Date/DateTime.model';
import type {MetricModel} from '../../../../core/domain/Metric/Metric.model';
import type {Period} from '../../types';

import {logger} from '../../../../utils/logger';
import {getStartDateOfPeriod} from '../../utils';
import {FetchMetricsQuery} from '../ports/FetchMetrics/FetchMetrics.query';

@injectable()
export class FetchMetricsUseCase {
  constructor(
    @inject(FetchMetricsQuery)
    private readonly query: FetchMetricsQuery,
  ) {}

  async exec({
    endDate,
    period,
  }: FetchMetricsUseCase.Props): Promise<FetchMetricsUseCase.Response> {
    try {
      const startDate = getStartDateOfPeriod({endDate, period});

      return this.query.exec({
        endDate,
        startDate,
      });
    } catch (e) {
      logger.error(e);

      throw e;
    }
  }
}

export namespace FetchMetricsUseCase {
  export type Props = {
    endDate: DateTimeModel;
    period: Period;
  };
  export type Response = MetricModel[];
}
